import React, { useContext, useState } from 'react';
import { useClickRef } from '@make-software/csprclick-ui';

import { ConnectedAccountContext } from '@/contexts';
import { SendMessageModal } from '@/components';
import {
  Background,
  HeroTitle,
  HeroSubtitle,
  Button,
  Section
} from './styled';

export const HeroSection: React.FC = () => {
  const [showComposeMessageModal, setShowComposeMessageModal] = useState<boolean>(false);
  const { connectedAccount } = useContext(ConnectedAccountContext);
  const clickRef = useClickRef();

  return (
    <Background>
      <Section>
        <HeroTitle>Encrypted on-chain messaging</HeroTitle>
        <HeroSubtitle>From one account to another</HeroSubtitle>

        {connectedAccount
          ? <Button onClick={() => setShowComposeMessageModal(true)}>
            Compose
          </Button>
          : <Button onClick={() => clickRef?.signIn()}>
            Connect Wallet
          </Button>
        }
      </Section>

      <SendMessageModal
        isOpen={showComposeMessageModal}
        onClose={() => setShowComposeMessageModal(false)}
      />
    </Background>
  );
};
